export const AUTOMATIC_PENTESTING = {
  TITLE: 'Automated Pentesting',
  DASHBOARD_CARD: {
    TITLE: 'Dashboard',
    DESCRIPTION:
      'Overview of identified vulnerabilities in your infrastrucure, ' +
      'highlighting critical issues and recent detections for quick insight. ',
    URLS: {
      HISTORIC: 'Historic Vulnerabilities Dashboard',
      LAST_SCAN: 'Last Scan Dashboard',
    },
  },
  REPORT_CARD: {
    TITLE: 'Reports',
    DESCRIPTION:
      'A detailed vulnerability report encompassing both internal and external surfaces. ' +
      'This report provides an in-depth analysis of potential entry points and risks ' +
      'that could be exploited from within or outside the network',
    DOWNLOAD: 'Last External Surface Scan Report',
    INTERNAL: 'Last Vulnerability Scan Report',
    EXTERNAL: 'Last External Surface Scan Report',
    CLOUD: 'Last Cloud Audit Report',
    CLOUD_DASHBOARD: 'Cloud Audit Dashboard',
  },
  CONFIGURATION_CARD: {
    TITLE: 'Documentation',
    DESCRIPTION:
      'Client connection guides, including steps for securrely connecting client environments ' + 'with the platform. ',
    AWS: 'Connecting Your Private Networks with Qalea (AWS)',
    GCP: 'Connecting Your Private Networks with Qalea (GCP)',
    OTHER: 'Connecting Your Private Networks with Qalea (Other Cloud Providers)',
    READ_ONLY_AWS: 'Create Read-Only User in Your Cloud for Asset Discovery (AWS)',
    READ_ONLY_GCP: 'Create Read-Only User in Your Cloud for Asset Discovery (GCP)',
  },
  PENDING_ACTIONS: {
    TITLE: 'Pending Actions',
    DESCRIPTION:
      'Here you can see a prioritized list of unresolved vulnerabilities and recommended actions, ' +
      'keeping security efforts focused and actionable.',
    INSIGHTS_NOT_YET_AVAILABLE:
      'Pending Actions will be available once sufficient scan data has been collected. ' +
      'Please check back later to view insights and patterns as they emerge over time.',
  },
}
